
const checkoutMain = require('./pages/checkout/checkout');

checkoutMain.init();


// WEBPACK FOOTER //
// ./cartridges/app_puntroma_core/cartridge/js/main.js